export const pageTitleStoreKey = 'title';
